import React, { useEffect, useRef, useState } from "react";
import ReactPaginate from "react-paginate";
import { RelatedContentContainer } from "./style";
import { RelatedContentShadowCard } from "../Cards";
import { useIntersectionObserver, useUnsetGrid } from "../hooks";
import RelatedContentTitle from "../Title";

const PAGE_SIZE = 12

function Paginator({ onPageChange, pageRangeDisplayed, pageCount, forcePage }) {
	return <div className="rel-content__section__paginator"><ReactPaginate
		nextLabel="Next"
		previousLabel="Prev"
		activeClassName="active"
		breakLabel={null}
		renderOnZeroPageCount={null}
		marginPagesDisplayed={0}
		onPageChange={onPageChange}
		pageRangeDisplayed={pageRangeDisplayed}
		pageCount={pageCount}
		forcePage={forcePage}
	/></div>
}

const RelatedContent = props => {
	const {
		title,
		titleUrl,
		titleUrlTarget,
		subtitle,
		listFrom,
		manual,
		auto,
		relatedContentSectionHtmlId,
		linkText,
		showHighlightedDescription,
		showDate
	} = props

	const contentWrapperRef = useRef(null)

	const animate = useIntersectionObserver(contentWrapperRef)

	let contentList = (listFrom === 'auto') ? auto : manual?.sort((a, b) => Number(b.manualHighlight) - Number(a.manualHighlight));

	const [pageOffset, setPageOffset] = useState(0)
	const topOfComponent = useRef(null)

	function handlePaginationChange(page) {
		setPageOffset(page.selected);
		topOfComponent.current.scrollIntoView()
	}

	const [pageRangeDisplayed, setPageRangeDisplayed] = useState(7)
	useEffect(() => {
		// workaround to make sure that it always shows only 7 indexes
		if (pageOffset > 0 && pageOffset < 6) setPageRangeDisplayed(6)
		else setPageRangeDisplayed(7)
	}, [pageOffset])
	useUnsetGrid(topOfComponent)
	if (contentList.length === 0) return <div style={{ minHeight: '50px', display: 'flex', alignItems: 'center' }}><p>No content available, please check the authoring dialog.</p></div>
	const pages = Array(Math.round(contentList.length / PAGE_SIZE)).fill(0).map((v, i) => contentList.slice(i * PAGE_SIZE, i * PAGE_SIZE + PAGE_SIZE))
	const paginator = <Paginator
		forcePage={pageOffset}
		pageRangeDisplayed={pageRangeDisplayed}
		pageCount={Math.ceil(contentList?.length / PAGE_SIZE)}
		onPageChange={(page) => { handlePaginationChange(page) }}
	/>
	const items = pages[pageOffset] || contentList
	return <RelatedContentContainer id={relatedContentSectionHtmlId} ref={topOfComponent} hidePaginator={pages?.length <= 1}>
		<RelatedContentTitle title={title} titleUrl={titleUrl} titleUrlTarget={titleUrlTarget} subtitle={subtitle} />
		{paginator}
		<div ref={contentWrapperRef} className={`rel-content__section__items__grid${animate ? " animate" : ""}`}>
			{items.map((content, index) => <RelatedContentShadowCard key={index} linkText={linkText} content={content} showHighlightedDescription showDate={showDate}/>)}
		</div>
		{paginator}
	</RelatedContentContainer>
}

export default RelatedContent;
